/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { progressbufferOff } from "src/Actions/Admin/adminActions";
import "./styles.scss";
import { useTranslation } from 'react-i18next';

const ProgressButton = (props) => {
  const { t } = useTranslation();
  const {
    text,
    onClick = () => {
      console.log("Function Called");
    }
  } = props;
  const [progressCount, setProgresscount] = useState(0);
  const dispatch = useDispatch();
  const progressMax = text === t('continue') ? 100 : 90;
  const progressSpeed = text === t('continue') ? 10 : 120;
  const buffer = useSelector((state) => state.admin.progressBuffer);
  useEffect(() => {
    loader();
  }, []);

  useEffect(() => {
    if (!!buffer) {
      calculateProgressCount();
    }
  }, [buffer]);

  const loader = () => {
    for (let i = 1; i <= progressMax; i++) {
      setTimeout(() => setProgresscount(i), i * progressSpeed);
    }
  };
  const action = () => {
    text === (t('creatingAccount') + '...')
      ? dispatch(progressbufferOff(t('accAdded')))
      : dispatch(progressbufferOff(t('accUpdated')));
  };

  const calculateProgressCount = () =>{
    for (let i = 90; i <= 100; i++) {
      setTimeout(() => {
        setProgresscount(i);
        if (i === 100) {
          action();
        }
      }, i * 50);
    }
  }
  
  return (
    <button
      className={text === t('continue') ? `loadingbtn continue` : "loadingbtn"}
      onClick={onClick}>
      <span style={{ background: "#013E51" }}>
        <span
          className='progress'
          style={{ width: `${progressCount}%` }}></span>
      </span>
      <span className='text'>{text}</span>
    </button>
  );
};

export default ProgressButton;